"use strict";var e=require("./index-cjs-Be_poZvc.js");require("antd");var t=require("styled-components"),r=require("react/jsx-runtime"),a=require("react");require("./FeatureDisplay-cjs-CEbtX-nM.js"),require("./ButtonSeeMore-cjs-Cw-QPkVV.js"),require("./_variables-cjs-DcQBq1-A.js");var o=require("./index-cjs-31i0NxrX.js"),i=require("./getRandomNumber-cjs-BWCcCUug.js");function n(e){return e&&e.__esModule?e:{default:e}}require("@apollo/client"),require("./CategoryModel-cjs-CxTItWYs.js"),require("./submitGTAG-cjs-CSxmcU2c.js"),require("./submitGTM-cjs-DnOK_Bu3.js"),require("./_rollupPluginBabelHelpers-cjs-D0ujuojI.js"),require("./useUIConfiguration-cjs-DRLB6mgC.js"),require("./validationIssue.fragment-cjs-Cw-mgojl.js"),require("./cache-cjs-C83XsaeF.js"),require("./retryPurchaseEcommerceCart-cjs-Dxxa4BX5.js"),require("./index-cjs-Drtm32y2.js"),require("./setStore-cjs-CCxzDwjd.js"),require("./searchProducts-cjs-DUWfXcc2.js"),require("./constants-cjs-e5UqaYX5.js"),require("./useIsMobile-cjs-B4VfEOkY.js"),require("./device-cjs-r5XEfyJx.js"),require("./isCSR-cjs-Bfr_4TqH.js"),require("@sentry/browser"),require("./addUserInteraction-cjs-D4qW1TOG.js"),require("./updateCustomerWithProxy-cjs-DEH5OEA9.js"),require("./Icon-cjs-C3E8bi2m.js"),require("prop-types"),require("./no-img-cjs-kWjbGoDS.js"),require("./isSSR-cjs-ZlipN6k2.js");var s=n(t);const c=s.default.div.withConfig({displayName:"styles__FeaturedCategoriesWrapperStyles",componentId:"sc-1se7l6t-0"})([".featured-categories__items,.box__items{display:grid;grid-template-columns:repeat(auto-fit,minmax(0,1fr));grid-auto-columns:1fr;padding:2rem;gap:10px;margin-top:8px;@media screen and (max-width:1200px){grid-template-columns:repeat(4,minmax(0,1fr));}@media screen and (max-width:768px){gap:12px;padding:10px;margin-bottom:16px;}}.featured-categories__item,.box__item{display:flex;justify-content:center;align-items:flex-start;}.box__title{display:flex;justify-content:center;padding-top:40px;font-size:20px;font-weight:var(--typography-weight-bold);}.box__container,.featured-categories__container{background:#ffffff;box-shadow:0px 4px 16px rgba(56,56,56,0.12);border-radius:12px;width:100%;margin-top:20px;margin-bottom:20px;@media screen and (max-width:768px){box-shadow:none;border-radius:none;padding:1rem;display:contents;}}.box__item_number{color:var(--character-secondary,#616161);font-size:12px;font-style:normal;font-weight:var(--typography-weight-semiRegular);line-height:18px;letter-spacing:0.06px;}.box__item_title{text-align:center;width:100%;max-width:8rem;font-size:14px;margin-top:4px;color:var(--character-primary,#000000);@media screen and (max-width:768px){font-size:12px;line-height:0.8rem;}@media screen and (max-width:576px){font-size:10px;}}.featured-categories__title,.box__title{@media screen and (max-width:768px){display:flex;justify-content:center;}}.box__avatar{&.ant-avatar.ant-avatar-circle{@media screen and (max-width:768px){width:75px;height:75px;min-width:unset;min-height:unset;}}}"]),l=s.default(o.T).withConfig({displayName:"TitleItems__ItemsTitleStyles",componentId:"sc-sy0uuc-0"})(["display:flex;justify-content:center;margin-top:12px;font-weight:var(--typography-weight-semiBold);color:var(--character-primary,#000000);.items__title{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%;font-size:14px;}"]),u=({Wrapper:e,text:t})=>r.jsx(e,{text:t,className:"wrapper-title"}),p=({text:e})=>r.jsx(u,{Wrapper:l,text:e}),m=({categories:e,showTitle:t})=>r.jsx(c,{children:r.jsxs("div",{className:"featured-categories__container","data-testid":"categorySkeletonTree",children:[t?r.jsx(o.B,{text:t,className:"featured-categories__title"}):null,r.jsx("div",{className:"featured-categories__items",children:e?.map((e,t)=>r.jsx("div",{className:"featured-categories__item","data-testid":`category-${t+1}`,children:r.jsxs(o.A,{onClick:()=>{},currentItem:e,children:[r.jsx(o.a,{src:null}),r.jsx(p,{text:e.name})]})},e.key))})]})}),d=({Wrapper:e,showTitle:t,categoryContext:o})=>{const{categoryTree:n,loading:s,onClickCategoryTreeItem:c,hasPromotions:l,promotions:u,initialCategories:p}=o,d=Array.from({length:8},(e,t)=>({key:Math.floor(Date.now()*i.g()+t),name:"..."})),[x,g]=a.useState(p);return a.useEffect(()=>{if(0===n?.length)return;const e=n.filter(e=>!0===e.isFeatured),t=e.length;if(l){const r=e.slice(0,t<8?t:7);g([...r,u])}else{const r=e.slice(0,t<8?t:8);g(r)}},[l,u,s]),s&&!p?.length?r.jsx(m,{categories:d,showTitle:t}):r.jsx(e,{onClick:e=>{e&&c(e,"featured categories")},items:x,showTitle:t})},x=t.css`
  .category-level-2:hover {
    background-color: transparent;
  }

  .category-level-2.ant-menu-submenu:hover > .ant-menu-submenu-title {
    &:hover {
      background-color: var(--color-primary-opacity-ten) !important;
    }
  }

  .category-level-2:hover {
    cursor: pointer;
  }

  .category-level-2 .ant-menu-item-group-title {
    color: #000000;
  }

  .subTitle-button:hover {
    background-color: var(--color-primary-opacity-ten) !important;
  }

  .subTitle-button .ant-menu-title-content > button {
    color: var(--color-primary);
  }

  .category-level-3 {
    color: #000000;
    &:hover {
      color: #000000;
      background-color: var(--color-primary-opacity-ten) !important;
    }
  }
  .ant-menu-item.ant-menu-item-only-child.subTitle-button {
    margin: 0px;
    color: #000000;
    background-color: transparent;
    &:hover {
      background-color: var(--color-primary-opacity-ten) !important;
      color: var(--color-primary) !important;
    }
  }

  .ant-menu-item.ant-menu-item-only-child.category-level-2:hover {
    background-color: var(--color-primary-opacity-ten) !important;
  }

  .category-level-2 .ant-menu-title-content {
    color: #000000;
    &:hover {
      cursor: pointer;
      color: #000000;
      font-weight: var(--typography-weight-semiBold);
    }
  }
  .category-level-2.ant-menu-item-selected {
    background-color: transparent;
  }

  .category-level-3.ant-menu-item-selected {
    background-color: transparent;
  }

  .ant-menu-submenu.submenuCategory > ul.ant-menu {
    border-radius: 8px;
    left: 300px;
    padding: 20px 0px 20px 20px;
    border-right: 5px solid #ffffff;
    max-height: min(50vh, 500px);
  }

  .ant-menu-submenu.ant-menu-light {
    min-width: 300px;
    max-width: 440px;
  }

  .ant-menu::before {
    content: none;
  }
`,g=t.createGlobalStyle`
  body {
    ${x}
  }
`;exports.CategoryTree=e.C,exports.CategoryTreeProvider=e.a,exports.useCategoryTreeContext=e.u,exports.CategoryGlobalStyle=g,exports.FeaturedCategories=({featuredCategoriesTitle:t})=>{const{copies:a,...i}=e.u(),{featuredCategories:n={}}=a;return r.jsx(d,{Wrapper:e=>r.jsx(o.b,{...e,Decorator:c,copy:n}),showTitle:t,categoryContext:i})};